<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .empty-state {
    padding: utils.in_rem(24px);
    text-align: center;
    color: colors.get("textGrey");
    @include mixins.body1();
  }
</style>

<script>
  export let message;
</script>

<div class="empty-state">
  {message}
</div>
